import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f1cbe1d&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f1cbe1d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1cbe1d')) {
      api.createRecord('4f1cbe1d', component.options)
    } else {
      api.reload('4f1cbe1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f1cbe1d&lang=pug", function () {
      api.rerender('4f1cbe1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/bookClass/todayBooking/index.vue"
export default component.exports